export const INVENTORY_EXCLUDE_ATTRIBUTE = 'data-leo-inventory-exclude';

export const MAX_LABELS = 20;
